import { defineAction } from '~/prix'
import propertyImprovementsDeleteAction from './propertyImprovementsDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const propertyImprovementsDeleteDefinition = defineAction({
  ...propertyImprovementsDeleteAction,
  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default propertyImprovementsDeleteDefinition
